import HiringHeroSection from "../components/HiringSection/HiringHeroSection";

const Hiring = () => {
  return (
    <div>
      <HiringHeroSection />
      {/* <HiringCtA/> */}
    </div>
  );
};

export default Hiring;
